<template>
    <!-- 次卡 -->	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
                <el-form-item v-show="dataTypeShow" >
                <el-input-number  v-model="limitValue" :min="0" :max="20000"></el-input-number>
				</el-form-item>
				<el-form-item  style="width:100px">
                <el-select v-model="dataType"  placeholder="数据类型"  @change="ChangeShow()">
                <el-option    value="0" label="未使用">未使用</el-option>
		        <el-option    value="1" label="已使用">已使用</el-option>
                </el-select>					
				</el-form-item>
 				<el-form-item v-if="TenancyId=='0'||TenancyId==null">
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" @change="ChangeList" >
                 <el-option
               v-for="item in optionsShop"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				 
                </el-form-item>               
						
				<el-form-item>
                <el-date-picker
                  v-model="StartDate"
                  type="date"
                 placeholder="选择开始日期">
                 </el-date-picker> 
				</el-form-item>
				
                <el-form-item style="width:100px">
                <el-select v-model="Type" placeholder="是否过期" >
                <el-option    value="0" label="未过期">未过期</el-option>
		        <el-option    value="1" label="已过期">已过期</el-option>
                </el-select>				
				</el-form-item>	
                <el-form-item>
                <el-select v-model="Sort" placeholder="套餐次数排序">
                <el-option    value="1"  label="套餐次数升序">剩余次数升序</el-option>
		        <el-option    value="0"  label="套餐次数降序">剩余次数降序</el-option>
                </el-select>				
				</el-form-item>								
                <el-form-item>
                <el-select v-model="comboId" clearable filterable  placeholder="套餐">
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"></el-option>
                </el-select>				
				</el-form-item>								
				<el-form-item>					
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="query" icon="el-icon-search">查询</el-button>
					<el-button size="width:100%; height:100%;" type="warning" :loading="reportLoading" v-on:click="exportReport" icon="el-icon-search">导出</el-button>
				</el-form-item>

			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="data" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="Rownumber" width="120">
			</el-table-column>
			<el-table-column prop="CreationTime" label="办理时间" width="180" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="姓名" width="180" sortable>
			</el-table-column>			
			<el-table-column prop="CardNumber" label="卡号" width="180" sortable>
			</el-table-column>
			<el-table-column prop="Phone" label="号码" width="180" sortable>
			</el-table-column>			
			<el-table-column prop="ComboName" label="套餐" width="240" sortable>
			</el-table-column>
			<el-table-column prop="Frequency" label="剩余次数" width="120" sortable>
			</el-table-column>	
			<el-table-column prop="FinalTime" label="截止日期" min-width="180" sortable>
			</el-table-column>			
			<!-- <el-table-column label="操作" width="150">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.row)">删除</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<!-- <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination> -->
    <el-pagination class="toolbarfoot"
      @current-change="handleCurrentChange"
       @size-change="handleSizeChange"
      :page-sizes="[100, 200, 300, 400]"
      :page-size="PageSize"
      layout="sizes, prev, next" style="float:right;"
      >
    </el-pagination>			
		</el-col>
	</section>
</template>
<script>
import {mapGetters} from 'vuex';
import {ExportSurplusFrequencyCard,getShopInfor,SurplusFrequencyCard,FrequencyCardComboList} from '../../../../api/api';
export default {
	data(){
		return {
			reportLoading:false,
			dataTypeShow:false,
			limitValue:0,
			TenancyId:'',
			shopId:'',
			optionsShop:[],
			comboId:'',
			StartDate:'',
			value:'',
			dataType:'0',
			Type:'0',
			Sort:'0',
			options:[],
			total:0,
			page:1,
			listLoading:false,
			filters:{
              name:''
			},
            PageSize:100,
			sels: [],//列表选中列
			data:[],
		}
	},
	methods:{
		exportReport()
			{
				this.reportLoading=true;
			    let para = {
					PageIndex: this.page,					
					PageSize:this.PageSize,
					Type:this.Type,
					Sort:this.Sort,
					StartDate:this.StartDate,
					ComboId:this.comboId,
					DataType:this.dataType,
					TenancyId:this.shopId,
					LimitValue:this.limitValue
				};
  				let downloadName="剩余次卡业务";
				 ExportSurplusFrequencyCard(para).then((res)=>{						 
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = downloadName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
						 this.reportLoading=false;
					 }
					 else
					 {
						 this.reportLoading=false;
					 }
		   })
			},		
		ChangeShow(){
			  if(this.dataType==1)
			  {this.dataTypeShow=true;}
			  if(this.dataType==0)
			  {this.dataTypeShow=false;}
		}, 
		 ChangeList()
         {
             console.log('1');
              this.optionList();           
         }, 
		...mapGetters(['getuserstate']),
		handleSizeChange(val){
			this.PageSize=val;
			this.page=1;
			this.getReport();
		},
		optionList(){
			let para={TenancyId:this.shopId}
		  FrequencyCardComboList(para).then((res)=>{
          this.options=res.data;
				 }).catch(error=>{
				 })
		},
		handleCurrentChange(val) {
				this.page = val;
				this.getReport();
			},
		selsChange: function (sels) {
				this.sels = sels;
			},
		query()
		{
		   this.page=1;
		//    if(this.StartDate=='')
		//    {
        //           this.$message({
		// 							message: '请选择查询开始日期',
		// 							type: 'error'
		// 						});	
		// 						return false;		   
		//    }
		   this.getReport();
		},
		getReport(){
			let para = {
					PageIndex: this.page,					
					PageSize:this.PageSize,
					Type:this.Type,
					Sort:this.Sort,
					StartDate:this.StartDate,
					ComboId:this.comboId,
					DataType:this.dataType,
					TenancyId:this.shopId,
					LimitValue:this.limitValue
				};
				this.listLoading = true;
				SurplusFrequencyCard(para).then((res)=>{
					// console.log(res);
					this.data =res.data.Data;
					this.listLoading = false;
				})
				.catch(error=>{
                 alert('网络错误');
                });
		},	
		getShopList()
           {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.optionsShop = res.data;
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
           },               

	}
	,
		mounted() {
			// this.getReport();
			this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
			this.getShopList();
			this.optionList();

		}
}
</script>



// WEBPACK FOOTER //
// FrequencyCard.vue?47949662